import { render, staticRenderFns } from "./GraphInsecticide.vue?vue&type=template&id=2a335962&"
import script from "./GraphInsecticide.vue?vue&type=script&lang=js&"
export * from "./GraphInsecticide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports